<ng-container [formGroup]="formGrp">
  <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="5"cdkAutosizeMaxRows="5" readonly [formControlName]="swissField!.options.key!"></textarea>
</ng-container>